import { Grid } from "@mui/material";
import React, { ReactElement } from "react";
import IconButton from "./IconButton";
import { Close } from "@mui/icons-material";

interface Props {
  children: ReactElement;
  handleRemove?: () => void;
}

const ListItem: React.FC<Props> = (props) => {
  const { children, handleRemove } = props;
  return (
    <Grid container direction={"row"} alignItems={"center"}>
      <Grid>{children}</Grid>
      {handleRemove && (
        <IconButton
          icon={<Close fontSize="small" />}
          onClick={handleRemove}
          label="Remove"
        />
      )}
    </Grid>
  );
};

export default ListItem;
